import { WebAuth } from 'auth0-js';
import { authStorageKeys } from './authStorageKeys';
export const AuthServiceFactory = ({ clientID, domain, audience, scope, redirectUri, silentUri, returnTo, }) => {
    const webAuth = new WebAuth({
        clientID,
        domain,
        audience,
        scope,
        redirectUri,
        leeway: 40,
        responseType: 'id_token token',
    });
    const cleanLocalStorageSession = () => {
        localStorage.removeItem(authStorageKeys.ACCESS_TOKEN);
        localStorage.removeItem(authStorageKeys.LOGGED_USER_EMAIL);
        localStorage.removeItem(authStorageKeys.ID_TOKEN);
        localStorage.removeItem(authStorageKeys.SUBJECT);
        localStorage.removeItem(authStorageKeys.USER_ID);
        localStorage.removeItem(authStorageKeys.COMPANY_ID);
        localStorage.removeItem(authStorageKeys.PERSONAS);
        localStorage.removeItem(authStorageKeys.APPLICATIONS);
    };
    return {
        retrieveLoggedSession: () => new Promise((resolve, reject) => {
            cleanLocalStorageSession();
            webAuth.renewAuth({ redirectUri: silentUri }, (err, data) => {
                if (!err && data && data.accessToken && data.idToken && data.idTokenPayload) {
                    const curUser = localStorage.getItem(authStorageKeys.USER_ID);
                    const { companyId, userId, userPersonas: personas, applications } = data.idTokenPayload[`${audience}/app_metadata`];
                    if (curUser && curUser !== userId) {
                        reject();
                        return;
                    }
                    if (!userId) {
                        reject('Invalid user id in token payload');
                    }
                    if (!companyId) {
                        reject('Invalid company id in token payload');
                    }
                    localStorage.setItem(authStorageKeys.ACCESS_TOKEN, data.accessToken);
                    localStorage.setItem(authStorageKeys.ID_TOKEN, data.idToken);
                    localStorage.setItem(authStorageKeys.SUBJECT, data.idTokenPayload.sub);
                    localStorage.setItem(authStorageKeys.USER_ID, userId);
                    localStorage.setItem(authStorageKeys.COMPANY_ID, companyId);
                    localStorage.setItem(authStorageKeys.PERSONAS, personas);
                    localStorage.setItem(authStorageKeys.APPLICATIONS, applications);
                    resolve({
                        token: data.accessToken,
                        userId,
                        companyId,
                        personas,
                        applications,
                    });
                }
                else if (err && err.error === 'timeout') {
                    reject(err);
                }
                else {
                    reject(err);
                }
            });
        }),
        logout: () => {
            cleanLocalStorageSession();
            webAuth.logout({ returnTo });
        },
        login: () => {
            webAuth.authorize({ redirectUri });
        },
    };
};
//# sourceMappingURL=auth0Login.service.js.map